/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 * The tooltip component for ChartDynamic
 *
 * @author Yakov Gushchin
 * @author Maxim Fedorov
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.1.0
 */

import { formatBalance } from '../../../../../utils/formatText';
import { IChartTooltipItem, IChartTooltipItemTemplate, IChartTooltipWrapperTemplate } from '../../chartTypes';

export const ChartDynamicTooltipWrapperTemplate = (props: IChartTooltipWrapperTemplate): string => `

    <div class="g2-tooltip chart-dynamic__tooltip" data-component="chartTooltipDynamic">

        <!-- TOOLTIP TITLE -->
        <div class="g2-tooltip-title chart-dynamic__title" data-name="tooltipTitle">
            <div class="tooltip__title-date" data-name="titleDate">${props.account}</div>
        </div>

        <!-- TOOLTIP ITEMS -->
        <ul class="tooltip__items" data-name="tooltipItems">
            ${props.items.map((item: IChartTooltipItem, index: number) =>
          ChartDynamicTooltipItemTemplate(
              { item, index, currency: props.currency, mapIdToLabel: props.mapIdToLabel }),
      ).join('')}
        </ul>

    </div>
`;

export const ChartDynamicTooltipItemTemplate = (props: IChartTooltipItemTemplate): string =>
    `<li class="tooltip__item" data-index=${props.index} data-name="${props.item.id}">
        <div class="tooltip-row">
            <span class="tooltip__item-color" style="background-color:${props.item.color};"
                data-name="itemColor"> </span>
            <span class="tooltip__item-info" data-name="itemInfo">
                ${props.mapIdToLabel[props.item.name]?.title ?? props.item.name}
            </span>
            <span class="tooltip__item-price" data-name="itemPrice">
                ${formatBalance(props.item.value)} ${props.currency}</span>
        </div>

        <span class="tooltip-info__item-subtitle" data-name="itemSubTitle">
            ${props.mapIdToLabel[props.item.name]?.subTitle ?? ''}
        </span>
    </li>`;
